<div class="help__header">
    <h4>User Assistance</h4>
    <a class="help__close" href="javascript:void(0)" (click)="closePanel()"><i class="material-icons">close</i></a>
</div>

<div class="help__body">
    <iframe class="contentPanel" #helpContentFrame></iframe>
</div>

<div class="help__footer">Version: {{productVersion}}</div>